export const testKonturApi = "https://api.testkontur.ru";

export const testKonturApiCandy = testKonturApi + "/candy";

export const testKonturApiPicklist = testKonturApi + "/picklist";

export const localCandyApi = candyApiUrlAtHost("localhost.testkontur.ru");

export const localNidus = `https://localhost.testkontur.ru:8099/nidus`;

export function candyApiUrlAtHost(host: string): string {
    return `https://${host}:9182`;
}
